import React, { FC } from 'react';
import { NextStepButton, RequestStepContainer } from '../components';
import styled from 'styled-components';
import { RequestTutoringFields, useCurrentFormValues } from '../request-tutoring-form.logic';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useCurrentOffer } from 'logic/hooks/useCurrentOffer';
import { FormFieldSubject } from 'components/form-fields/form-field-subject/form-field-subject';
import { useSelector } from 'react-redux';
import { getSubjectsByNumber } from 'logic/store/subject/subject.selectors';
import { mapSubjectByNumberToSubjectSelectOption } from 'logic/store/subject/subject.logic';
import { SubjectsByNumber } from 'logic/store/subject/subject.model';
import { Text } from 'components/text/Text';

const Wrapper = styled.div`
  width: 50%;
  min-width: 200px;

  .ant-form-item {
    margin: 0;
  }
`;

export const SubjectStep: FC = () => {
  const { offer } = useCurrentOffer();
  const subjectsByNumber = useSelector(getSubjectsByNumber);
  const { subjects } = useCurrentFormValues();
  const offerSubjectsNumbers = offer?.subjects?.filter(Boolean)?.map(Number);
  const firstName = offer?.user?.firstName;
  const subjectOptions =
    subjectsByNumber && offerSubjectsNumbers
      ? (offerSubjectsNumbers.map((num) => subjectsByNumber[num]) as SubjectsByNumber)
      : [];
  const buttonDisabled = !subjects?.length;

  return (
    <RequestStepContainer
      title={translate(translationKeys.requestTutoringFlow.privateRequest, { firstName })}
    >
      <Text size={16}>
        {translate(translationKeys.requestTutoringFlow.inWhichSubjectDoYouNeedAHelp)}
      </Text>
      <Wrapper>
        <FormFieldSubject
          name={RequestTutoringFields.Subjects}
          mode={'multiple'}
          placeholder={translate(translationKeys.requestTutoringFlow.whatSubjectPlaceholder)}
          subjectOptions={mapSubjectByNumberToSubjectSelectOption(subjectOptions)}
        />
      </Wrapper>
      <NextStepButton disabled={buttonDisabled} />
    </RequestStepContainer>
  );
};
